// Third-party
import React from 'react';

// Types
import { Account } from '@/types/planning';

// Utils
import { formatMessage, FormattedMessage } from '@/utils/i18n';

// Components
import { LoadingSpinner } from '@/views/components/common';

type Props = {
  selectedAccount?: Account;
  isLoading?: boolean;
};

const PlanAccountLabel: React.FC<Props> = ({ selectedAccount, isLoading }: Props) => (
  <span className="plan-account-label">
    <FormattedMessage id="PortfolioEditorBuilder.PlanAccount.PlanAccountTitle" />
    {isLoading ? (
      <LoadingSpinner />
    ) : (
      <span className="plan-account-name">{selectedAccount?.name ?? formatMessage('PortfolioEditorBuilder.RiskProfile.Assign')}</span>
    )}
  </span>
);

export default PlanAccountLabel;
